import { useCan, useSelectedDealer } from "components";
import { useTypedQuery } from "hooks";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { AccessKeysDashboardQueryKeys } from "modules/AccessKeysDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { PublicAccountWithApiKey } from "modules/AccessKeysDashboard/queryKeys";

const sortAccounts = (accounts: PublicAccountWithApiKey[]) => accounts.sort((a, b) => b.created_on.localeCompare(a.created_on));

export const useAccountsQuery = () => {
  const { selectedDealer } = useSelectedDealer();
  const canListAccounts = useCan(ACL_ACTIVITIES.List, ACL_RESOURCES.PublicAPIAccount);

  return useTypedQuery({
    queryKey: AccessKeysDashboardQueryKeys.accounts,
    queryFn: async ({ baseUrl, endpoint }) => {
      if (!selectedDealer?.id) return [];

      return (await ApiInstance.post(endpoint, { dealer_id: selectedDealer.id }, baseUrl)).data.accounts;
    },
    enabled: canListAccounts && Boolean(selectedDealer?.id),
    refetchOnDependencies: [selectedDealer?.id, canListAccounts],
    select: sortAccounts
  });
};
